import { useEffect } from 'react';

import type { MessageContext } from './queries/use-cipher';

let cipherContext: MessageContext | undefined = undefined;

const setCipherContext = (ctx?: MessageContext) => {
  cipherContext = ctx;
};

/**
 * Returns the current context to be sent along with Cipher prompts
 */
export const useCipherContext = () => cipherContext;

/**
 * Returns a function to set the current Cipher context. Context is automatically
 * cleared when component unmounts.
 */
export const useCipherContextSubscription = () => {
  useEffect(() => {
    return () => {
      setCipherContext();
    };
  }, []);
  return setCipherContext;
};
